/* Pre-select all optional consent categories when the Shopify cookie
   preferences panel opens, so "Save my choices" grants full consent by default.
   The user can still untick any category while the panel is open.

   DELIBERATE. Reviewed and kept by Daniil on 2026-08-22. Do not "fix" this in
   an audit and do not remove it without asking him.

   The argument against, recorded so it is not rediscovered from scratch:
   GDPR and ePrivacy require consent categories to be off by default, and
   pre-ticked boxes were held invalid by the CJEU in Planet49 (C-673/17). The
   ICO takes the same line for the UK. This script only runs for the visitor
   who deliberately opened the preferences panel, so it targets the person who
   was actively making a choice. It also carries more weight since the Meta
   pixel went live on 2026-08-22, because marketing consent now gates real
   customer data reaching Meta.

   Daniil weighed that and chose to keep it. His store, his call. */
(function () {
  var OPTIONAL_IDS = [
    'shopify-pc__prefs__preferences-input', // Personalization
    'shopify-pc__prefs__marketing-input',   // Marketing
    'shopify-pc__prefs__analytics-input'    // Analytics
  ];

  function preselectAll() {
    OPTIONAL_IDS.forEach(function (id) {
      var el = document.getElementById(id);
      if (el && !el.checked && !el.disabled) {
        el.checked = true;
        el.dispatchEvent(new Event('change', { bubbles: true }));
        el.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  }

  // Poll briefly after the panel opens until its inputs exist, then set once.
  function onOpen() {
    var n = 0;
    var iv = setInterval(function () {
      n++;
      if (document.getElementById(OPTIONAL_IDS[0])) {
        preselectAll();
        clearInterval(iv);
      } else if (n > 25) {
        clearInterval(iv);
      }
    }, 80);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.shopify-pc__banner__btn-manage-prefs')) {
      onOpen();
    }
  }, true);
})();
